
import { apiHelper } from "../apiHelper/apiHelper";
import {
  getFarmersFailure,
  getFarmersRequest,
  getFarmersSuccess,
  getFarmerDetailsFailure,
  getFarmerDetailsRequest,
  getFarmerDetailsSuccess,
  getFarmerFarmDetailsRequest,
  getFarmerFarmDetailsSuccess,
  getFarmerFarmDetailsFailure,
  getFarmerOrdersRequest,
  getFarmerOrdersSuccess,
  getFarmerOrdersFailure,
  deleteFarmerRequest,
  deleteFarmerSuccess,
  deleteFarmerFailure,
  assignConsultantRequest,
  assignConsultantSuccess,
  assignConsultantFailure,
  changeConsultantRequest,
  changeConsultantSuccess,
  changeConsultantFailure,
} from "../slices/farmersSlices";



// ========================== NEW API HANDLER =================

// get Farmers list
export const handleGetFarmersList = () => async (dispatch) => {
  const endPoint = "farmer/";
  const method = "GET";
  const state1 = getFarmersRequest;
  const state2 = getFarmersSuccess;
  const state3 = getFarmersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
 
};
 


// get Farmers list
export const handleGetFarmerDetails = (farmerId) => async (dispatch) => {
  const endPoint = `farmer/farmer-details/${farmerId}`;
  const method = "GET";
  const state1 = getFarmerDetailsRequest;
  const state2 = getFarmerDetailsSuccess;
  const state3 = getFarmerDetailsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
 
};
 


// ========================== DELETE  HANDLER =================

export const handleDeleteFarmer = (farmerId) => async (dispatch) => {
  const endPoint = `farmer/${farmerId}`;  // Supplier ID is appended to the endpoint
  const method = "DELETE";  // Use DELETE method to remove the supplier
  
  const state1 = deleteFarmerRequest; // Request state action (loading)
  const state2 = deleteFarmerSuccess; // Success state action
  const state3 = deleteFarmerFailure; // Failure state action
  const isToast = false; // Toast disabled (can be enabled if you wish)
  const isFile = false; // No file upload involved
  const isToken = true; // Include authentication token

  // Call apiHelper, passing dispatch correctly
  await apiHelper(
    endPoint,
    method,
    null,  // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,  // Ensure dispatch is passed properly
    isFile,
    isToast,
    isToken
  );
};



// ========================== NEW API HANDLER =================

// Get Farmer Farm Details
export const handleGetFarmerFarmDetails = (farmerId) => async (dispatch) => {
  const endPoint = `farmer/farms/${farmerId}`; // Replace farmerId dynamically
  const method = "GET";
  const state1 = getFarmerFarmDetailsRequest;
  const state2 = getFarmerFarmDetailsSuccess;
  const state3 = getFarmerFarmDetailsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;

  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


// ========================== NEW API HANDLER =================

// Get Farmer Orders
export const handleGetFarmerOrders = (farmerId) => async (dispatch) => {
  const endPoint = `order/farmer/${farmerId}`; // Dynamically add farmerId to the endpoint
  const method = "GET";
  const state1 = getFarmerOrdersRequest;
  const state2 = getFarmerOrdersSuccess;
  const state3 = getFarmerOrdersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;

  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};



// create Consultant
export const handleAssignConsultant = async (formData, dispatch) => {

  const endPoint = "user/assign-consultant";
  const method = "POST";
  const state1 = assignConsultantRequest;
  const state2 = assignConsultantSuccess;
  const state3 = assignConsultantFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};

// Change Consultant
export const handleChangeConsultant = async (formData, dispatch) => {

  const endPoint = "user/changeconsultant";
  const method = "POST";
  const state1 = changeConsultantRequest;
  const state2 = changeConsultantSuccess;
  const state3 = changeConsultantFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};